module.exports = __webpack_public_path__ + "static/media/mode-47.44be7587.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-47.svg
// module id = 1019
// module chunks = 2